import React from 'react';
import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

export const PackageType = () => {
    return (
        <OverlayTrigger placement='top' overlay={
            <Tooltip id='tooltip' className='top-right'>
                <FormattedMessage id='intl-msg:packageType.app.tooltip'/>
            </Tooltip>}>
            <span className={'label label-condensed label-primary'}>
                <FormattedMessage id='intl-msg:packageType.app' />
            </span>
        </OverlayTrigger>
    );
};

export default PackageType;
